module.exports = THREE;


//////////////////
// WEBPACK FOOTER
// external "THREE"
// module id = 28
// module chunks = 0